import Timeline from './timeline'

App.Timeline = App.Timeline || {}
App.Timeline = Timeline
